<template>
    <div class="ci-multiple-select">
        <label v-show="label">
            <span class="text-secondary" v-if="required">*</span>
            {{ label }}
        </label>
        <treeselect
            @open="adjustMenuHeight"
            :disableBranchNodes="disableBranchNodes"
            :placeholder="`${selectedOptions.length} ${$t('keyword26')} ${options.length} ${$t('keyword90')}`"
            v-model="selectedOptions"
            :multiple="true"
            :options="options"
            :limit="limit"
            clear-on-select
        />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
    components: {
        Treeselect,
    },
    props: {
        limit: {
            type: Number,
            default: 3,
        },
        label: {
            type: String,
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
        },
        disableBranchNodes: Boolean,
        required: Boolean,
        value: Array,
    },
    watch: {
        value: {
            handler() {
                this.selectedOptions = this.value
            },
            deep: true,
        },
        selectedOptions: {
            handler() {
                this.$emit('input', this.selectedOptions)
            },
            deep: true,
        },
    },
    data() {
        return {
            selectedOptions: [],
        }
    },
    methods: {
        adjustMenuHeight() {
            this.$nextTick(() => {
                let vue_treeselect = document.querySelector('.vue-treeselect__menu')
                if (vue_treeselect) {
                    if (window.innerHeight <= 820) {
                        vue_treeselect.style.setProperty('height', 200 + 'px')
                    } else if (window.innerHeight <= 620) {
                        vue_treeselect.style.setProperty('height', 150 + 'px')
                    }
                }
            }, 500)
        },
    },
    mounted() {
        this.selectedOptions = this.value
    },
}
</script>

<style lang="scss" scoped>
.ci-multiple-select {
    background-color: inherit;
    position: relative;
    margin-top: 8px;
    label {
        background-color: inherit;
        z-index: 1;
        position: absolute;
        margin: 0px;
        left: 8px;
        top: -8px;
        padding: 0 8px;
        color: #808080;
        margin: 0px;
        font-size: 12px;
        @media (max-width: 1200px) {
            font-size: 10px;
        }
    }
}
</style>
